if(!customElements.get('custom-slideshow')){
    class CustomSlideshow extends HTMLElement {
        constructor(){
            super();

            this.videos = this.querySelectorAll('video');
            this.animationType = this.dataset.animationType || 'none';
        }

        connectedCallback(){
            this.initializeSwiper();

            this.videos.forEach(video => {
                if(typeof video === 'undefined') return;
                video.addEventListener("loadeddata", e => {
                    video.classList.add('loaded');
                });

                if(video.readyState >= 2){
                    video.classList.add('loaded');
                }
            });

            this.initializeParallax();
        }

        async initializeSwiper(){
            this.swiperContainer = this.querySelector('.swiper-container');
            if(!this.swiperContainer) return;

            this.slides = this.querySelectorAll('.swiper-slide');
            if(this.slides.length <= 1) return;

            if(typeof Swiper === 'undefined'){
                await new Promise(resolve => {
                    const check = () => {
                        if(typeof Swiper !== 'undefined') resolve();
                        else requestAnimationFrame(check);
                    };
                    check();
                });
            }

            const autoplay = this.swiperContainer.dataset.autoplay === 'true';
            const speed = parseInt(this.swiperContainer.dataset.speed);
            const loop = this.swiperContainer.dataset.loop === 'true';
            const transition = this.swiperContainer.dataset.transition;

            const swiperSettings = {
                init: false,
                initialSlide: 0,
                loop: loop,
                centeredSlides: false,
                speed: 500,
                watchOverflow: true,
                observer: true,
                observeSlideChildren: true,
                watchSlidesProgress: true,
                autoHeight: false,
                on: {
                    init: () => {
                        const paginationBullets = this.querySelectorAll(".swiper-pagination-bullet");
                        if(paginationBullets.length > 0){
                            this.style.setProperty('--pagination-width', `calc(100% / ${paginationBullets.length})`);
                            paginationBullets.forEach((item, index) => {
                                item.setAttribute('data-index', `${index}`);
                            });

                            // set pagination color
                            const activeSlide = this.querySelector('.swiper-slide-active');
                            if(activeSlide){
                                const colorText = getComputedStyle(activeSlide).getPropertyValue('--color-text').trim();
                                this.style.setProperty('--color-pagination', `${colorText}`);
                            }
                            setTimeout(() => {
                                this.querySelector('.swiper-pagination')?.classList.add('loaded');
                                this.checkSwiperLock();
                            }, 500);
                        }
                    },
                    slideChange: () => {
                        const activePagination = this.querySelector(".swiper-pagination-bullet-active");
                        if(activePagination){
                            const activePaginationIndex = parseInt(activePagination.dataset.index);
                            this.style.setProperty('--pagination-translate-x', `calc(100% * ${activePaginationIndex})`);
                        }
                    },
                    transitionEnd: () => {
                        // set pagination color
                        const activeSlide = this.querySelector('.swiper-slide-active');
                        if(activeSlide){
                            const colorText = getComputedStyle(activeSlide).getPropertyValue('--color-text').trim();
                            this.style.setProperty('--color-pagination', `${colorText}`);
                        }
                    }
                }
            }

            if(transition === 'fade'){
                swiperSettings.effect = 'fade';
                swiperSettings.fadeEffect = {
                    crossFade: true
                }
            }

            if(this.swiperContainer.querySelector(".swiper-navigation-wrapper")){
                swiperSettings.navigation = {
                    nextEl: this.swiperContainer?.querySelector('.button-next'),
                    prevEl: this.swiperContainer?.querySelector('.button-previous')
                }
            }

            if(this.querySelector('.swiper-pagination')){
                swiperSettings.pagination = {
                    el: this.querySelector('.swiper-pagination')
                }
            }

            if(autoplay && !isNaN(speed)){
                swiperSettings.autoplay = {
                    delay: speed
                }
            }

            this.swiper = new Swiper(this.swiperContainer, swiperSettings);
            this.swiper.init();

            this.swiper.on("resize", this.checkSwiperLock.bind(this));

            this.setupFocusListeners();
        }

        checkSwiperLock(){
            if(!this.querySelector(".swiper-pagination")) return;
            
            if(this.swiper.isLocked){
                this.querySelector(".swiper-pagination").classList.add('hidden');
            }else{
                this.querySelector(".swiper-pagination").classList.remove('hidden');
            }
        }

        setupFocusListeners(){
            this.querySelectorAll(".button-next, .button-previous").forEach(button => {
                button.addEventListener('focus', () => {
                    button.classList.add('focused');
                    button.addEventListener('blur', () => {
                        button.classList.remove('focused');
                    }, { once: true });
                });
            });
        }

        initializeParallax(){
            if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
            
            gsap.registerPlugin(ScrollTrigger);

            if(this.animationType === 'zoom-in-out'){
                this.zoomInOut();
            } 
        }

        zoomInOut(){
            const childElements = this.querySelectorAll('parallax-element-section');
            if(childElements.length === 0) return;

            
            const target = childElements[0];
            const triggerEl = target;

            gsap.set(target, { scale: 0.8, opacity: 0, transformOrigin: "center center" });

            gsap.timeline({
                scrollTrigger: {
                    trigger: triggerEl,
                    start: "top-=300 center",
                    end: "bottom+=300 center+=100",
                    scrub: 1.5,
                    // markers: true,
                    invalidateOnRefresh: true
                }
            })
            .to(target, { scale: 1, opacity: 1, ease: "none", duration: 0.5 }, 0)
            .to(target, { scale: 1, ease: "none", duration: 0.90 })
            .to(target, { scale: 1.2, opacity: 0, ease: "none", duration: 0.05 });
        }
    }

    customElements.define('custom-slideshow', CustomSlideshow);
}